// x-nettskjema-embed.js

/*
Script delivered by Nettskjema.
Used to embed Nettskjema iframes. Calculates correct height etc.
Note: it is generally recommended to link to nettskjema instead of embedding.

Script is old it seems. Contains IE11 polyfill.
*/

export default function xNettskjemaEmbed() {

  (function nettskjema() {
    'use strict';
    var trustedOrigin = /^https?:\/\/(localhost|(nettskjema(-dev\d?|-test)?)\.uio\.no|nettskjema\.no)/;

    var iframes = null;

    function getIframe(contentWindow) {
      if (iframes === null) {
        iframes = getTrustedIframes();
      }
      for (var i = 0; i < iframes.length; i++) {
        if (iframes[i].contentWindow === contentWindow) {
          return iframes[i];
        }
      }
    }

    function getTrustedIframes() {
      var elements = document.getElementsByTagName('iframe');
      if (!elements || !elements.length) {
        return [];
      }

      var iframes = [];
      for (var i = 0; i < elements.length; i++) {
        if (trustedOrigin.test(elements[i].src)) {
          iframes.push(elements[i]);
        }
      }
      return iframes;
    }

    // Make sure console.log is defined
    if (!window.console) {
      window.console = { log: function noop() { } };
    } else if (typeof console.log !== 'function') {
      console.log = function noop() { };
    }

    function handleIframeMessage(e) {
      e = e.originalEvent || e;
      var origin = e.origin;

      if (trustedOrigin.test(origin)) {
        var iframe = getIframe(e.source);
        if(e.data === "scrollToStart") {
          iframe.scrollIntoView();
          return;
        }
        var height = (typeof e.data === 'string') ? parseInt(e.data, 10) : e.data;

        if (!iframe) {
          console.log('Nettskjema iframe - could not find a matching iframe with message source from origin: ', origin);
        } else if (isNaN(height)) {
          console.log('Nettskjema iframe - data retrieved was not a number: ' + (typeof e.data));
        } else {
          iframe.style.height = (height + 20) + 'px';
        }
      }
    }

    // CustomEvent polyfill for IE11
    (function () {
      if (typeof window.CustomEvent === "function") return false;

      function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: null };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
      }

      CustomEvent.prototype = window.Event.prototype;

      window.CustomEvent = CustomEvent;
    })();

    (function () {
      var throttle = function (type, name, obj) {
        obj = obj || window;
        var running = false;
        var func = function () {
          if (running) {
            return;
          }
          running = true;
          requestAnimationFrame(function () {
            obj.dispatchEvent(new CustomEvent(name));
            running = false;
          });
        };
        obj.addEventListener(type, func);
      };

      throttle('resize', 'optimizedResize');
    })();

    function postResizeMessage() {
      var iframe = iframes && iframes[0];
      if (iframe) {
        iframe.contentWindow.postMessage('resize', '*');
      }
    }

    if (window.addEventListener) {
      window.addEventListener('message', handleIframeMessage);
      window.addEventListener('optimizedResize', postResizeMessage);
    } else {
      window.attachEvent('onmessage', handleIframeMessage); // IE8
    }
  })();
}